<template>
  <div class="container">
    <header v-if="!isLayoutFlat">
      <div class="logo" style="width: 180px;">
        <router-link to="/">
          <img src="/mahatat-logo.svg" alt="Mahatat">
        </router-link>
      </div>

      <div class="header-menu-block">
        <div v-if="false" class="top-menu">
          <router-link to="/">Home</router-link>
          <router-link to="/movies">Movies</router-link>
          <router-link to="/series">TV series</router-link>
          <router-link to="/watchlist">Watchlist</router-link>
        </div>

        <div v-if="false" class="search">
          <a href="">Search</a>
        </div>
      </div>

      <div class="profile">
        <router-link v-if="user" to="/account/profile">{{ user.name }}</router-link>
        <router-link v-else to="/login">Login</router-link>
      </div>
    </header>

    <router-view />

    <footer v-if="!isLayoutSimple && !isLayoutFlat && !$screen.mobile">
      <div class="main">
        <section class="about">
          <router-link to="/">
            <img src="/mahatat-logo.svg" alt="Mahatat">
          </router-link>
          <p>Mahatat is one of the fastest growing VOD platforms
            which offers premium content sourced from Bollywood and the Arab region.</p>
        </section>

        <section class="menu">
          <div class="menu-col">
            <a href="https://accounts.mahatat.com/faq" target="_blank" rel="noopener">FAQ</a>
            <a href="https://accounts.mahatat.com" target="_blank" rel="noopener">Accounts</a>
            <a href="https://mahatat.com/privacy.html" target="_blank" rel="noopener">Terms of Services</a>
          </div>
        </section>

        <section class="follow">
          <h4>Follow us:</h4>
          <div class="social-links">
            <a href="https://www.facebook.com/MahatatApp" target="_blank" rel="noopener" class="facebook">Facebook</a>
            <a href="https://twitter.com/mahatatapp" target="_blank" rel="noopener" class="twitter">Twitter</a>
            <a href="https://www.instagram.com/mahatatapp" target="_blank" rel="noopener" class="instagram">Instagram</a>
          </div>
        </section>
      </div>

      <div class="copy">
        © 2020 Mahatat. All rights reserved.
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Layout',
  computed: {
    ...mapState('auth', ['user']),
    ...mapState(['isLayoutSimple', 'isLayoutFlat']),
  },
};
</script>

<style lang="less" scoped>
  .container {
    margin: 0 auto;
    max-width: 1140px;
    padding: 0 25px;
  }

  header {
    display: flex;
    height: 96px;
    align-items: center;
    position: relative;

    .header-menu-block {
      display: flex;
      flex-grow: 1;
      justify-content: flex-end;

      a {
        font-size: 1rem;
        margin: 0 25px;
        line-height: 25px;
      }

      .search {
        a {
          display: block;
          width: 24px;
          height: 24px;
          background: url('/assets/images/search-icon.png') 50% 50% no-repeat;
          text-indent: -99999px;
        }
      }
    }

    .profile {
      padding-left: 15px;
    }
  }

  footer {
    padding: 60px 25px;
    background-color: #1c1c1c;
    margin: 0 -25px;

    section {
      display: block;
    }

    .main {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-right: 200px;

      .about {
        flex-basis: 180px;

        p {
          font-size: .75rem;
          color: #737373;
          line-height: 33px;
        }
      }

      .menu {
        display: flex;
        flex-wrap: wrap;

        .menu-col:first-child {
          margin-right: 150px;
        }

        a {
          display: block;
          font-size: 1.5rem;
          margin-bottom: 29px;
        }
      }

      .follow {
        h4 {
          font-size: 1.3rem;
          margin-top: 0;
        }

        .social-links {
          a {
            display: block;
            height: 24px;
            padding-left: 40px;
            line-height: 24px;
            background-repeat: no-repeat;
            font-size: 1.2rem;
            color: #7CE7F2;
            font-weight: bold;
            margin: 32px 0;

            &.facebook {
              background-image: url('/assets/images/social-icon-fb.svg');
            }

            &.instagram {
              background-image: url('/assets/images/social-icon-inst.svg');
            }

            &.twitter {
              background-image: url('/assets/images/social-icon-tw.svg');
            }
          }
        }
      }
    }

    .copy {
      font-size: .75rem;
      color: #737373;
      border-top: 1px solid #737373;
      padding-top: 20px;
      margin-top: 20px;
    }
  }

  @media (max-width: 768px) {
    header {
      margin-bottom: 50px;
      justify-content: flex-end;

      .header-menu-block {
        order: 1;
        flex-grow: 0;

        .search {
          a {
            margin: 0;
          }
        }

        .top-menu {
          position: absolute;
          top: 96px;
          right: 0;
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          a {
            margin: 0;
            font-weight: bold;
            color: #999;
            margin-right: 15px;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }

      .logo {
        flex-grow: 1;
        order: 2;
        text-align: center;
        position: absolute;

        img {
          width: 65px;
        }
      }

      .profile {
        order: 3;
        padding-left: 0;
      }
    }

    footer {
      padding: 40px 25px;
    }
  }
</style>
